export default __webpack_public_path__ + "static/media/android-qrcode.c0176d49.png";